'use strict';

import MessageService from './message.service';

import './message.css';

const Message = angular
    .module('app.message', [])
    .service('Message', MessageService)
    .config((toastrConfig) => {
        angular.extend(toastrConfig, {
            allowHtml: true,
            closeButton: true,
            extendedTimeOut: 2000,
            progressBar: true,
            tapToDismiss: false,
            timeOut: 6000,
            iconClasses: {
                error: 'bg-danger',
                info: 'bg-info',
                success: 'bg-success',
                warning: 'bg-warning'
            },
      });
    })
    .name;

export default Message;


// WEBPACK FOOTER //
// ./src/app/common/core/services/message/message.module.js